import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://qpxxfdnzglnxyryawujz.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFweHhmZG56Z2xueHlyeWF3dWp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI5MzA0MTYsImV4cCI6MjA4ODUwNjQxNn0.mI71JjApI_OV2Wq9vm8EibwZQvot3EVtvdfgRpVJZL0';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
